import { useContext, useEffect, useState } from 'react'
import Context from './Context'
// Antd
import { Button, Input, message } from 'antd'
import { VscWorkspaceTrusted } from "react-icons/vsc";
// components
import BaseLayout from 'components/BaseLayout'
import TableComponent from 'components/Table'
import Modal from './Modal'
import { ColumnsType } from 'components/Table/interface'
// helpers
import MoreOptions from './Cells/MoreActions'
import StatusCell from './Cells/StatusCell'

const columns: ColumnsType<any> = [
  {
    title: 'Nombre',
    dataIndex: 'name',
    type: 'CommonCell'
  },
  {
    title: 'Descripcion',
    dataIndex: 'description',
    type: 'CommonCell'
  },
  {
    title: 'Estado',
    dataIndex: 'status',
    render: StatusCell
  },
  {
    title: '',
    dataIndex: 'id',
    render: MoreOptions
  }
]

const Layout: React.FC = () => {
  const {
    states: { page, searchInput, selectedUser, open },
    actions: { setFilterSelected, setPage, setSearchInput, onOpen },
    queryHandler: { isFetching, data }
  } = useContext(Context)
  const [filter, setFilter] = useState('')

  useEffect(() => {
    const time = setTimeout(() => {
      if (filter != searchInput) setSearchInput(filter)
    }, 600)
    return () => clearTimeout(time)
  }, [filter])

  return (
    <>
      <BaseLayout
        title="Roles"
        bordered={false}
        extra={
          <Button icon={<VscWorkspaceTrusted />} type="primary" style={{ display: 'flex', alignItems: 'center', }} onClick={() => onOpen('createUser')}>
            Agregar rol
          </Button>
        }
      >
        <TableComponent
          emptyData={data.length === 0 && !isFetching}
          columns={columns}
          data={data.slice((page - 1) * 9, page * 9)}
          rows={9}
          loading={isFetching}
          page={page}
          total={data.length}
          setPage={setPage}
        />
      </BaseLayout>
      <Modal key={`${selectedUser}-${open}`} />
    </>
  )
}

export default Layout
